var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmaill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 28,
    viewBox: "0 0 36 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8576 15.2197L1.46289 27.546C1.809 27.7249 2.18773 27.8178 2.57132 27.8178H33.4286C33.8163 27.8178 34.1941 27.7231 34.537 27.546L23.1427 15.2197L21.0308 17.5056C20.2271 18.3747 19.1372 18.8629 18.0003 18.8629C16.8635 18.8629 15.7736 18.3743 14.9695 17.5056L12.8576 15.2197Z",
    fill: "#744DFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7494 1.58301C35.9131 1.9536 36.0007 2.36273 36.0007 2.78169V25.0361C36.0007 25.4551 35.9135 25.8642 35.7494 26.2348L24.3555 13.9089L35.7494 1.58301Z",
    fill: "#744DFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.251245 1.58301L11.6452 13.9089L0.251245 26.2348C0.0859171 25.8605 7.31087e-05 25.4509 0 25.0361V2.78169C0 2.36273 0.0871589 1.9536 0.251245 1.58301Z",
    fill: "#744DFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.537 0.271795C34.1909 0.092885 33.8122 1.79401e-05 33.4286 0H2.57132C2.18366 0 1.80584 0.094698 1.46289 0.271795L16.1818 16.1942C16.6638 16.716 17.3179 17.0091 18 17.0091C18.6821 17.0091 19.3361 16.716 19.8182 16.1938L34.537 0.271795Z",
    fill: "#744DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmaill);
export default __webpack_public_path__ + "static/media/emaill.8a0c44cd5b79eeab6417e003b219aed9.svg";
export { ForwardRef as ReactComponent };